import originalFetchJsonp from 'fetch-jsonp';
import unfetch from 'unfetch';

export const fetch = window.fetch ? window.fetch : unfetch;
export const fetchJsonp = originalFetchJsonp;
